/**
 * Persists the in-person notetaker session bearer (and the meeting it scopes)
 * across page reloads within the same tab. The bearer is a server-issued
 * opaque token, valid for the lifetime of the InPersonSession row. We use
 * sessionStorage so closing the tab invalidates client state — the server
 * still tracks revocation independently.
 */

const STORAGE_KEY = 'gap:inPersonSession'

export interface StoredInPersonSession {
   bearerToken: string
   expiresAt: string
   meetingId: string
   orgId: string
}

export function readInPersonSession(): StoredInPersonSession | null {
   try {
      const raw = sessionStorage.getItem(STORAGE_KEY)
      if (!raw) return null
      const parsed = JSON.parse(raw) as StoredInPersonSession
      if (!parsed.bearerToken || !parsed.meetingId) return null
      if (new Date(parsed.expiresAt).getTime() < Date.now()) {
         sessionStorage.removeItem(STORAGE_KEY)
         return null
      }
      return parsed
   } catch {
      return null
   }
}

export function writeInPersonSession(value: StoredInPersonSession): void {
   sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value))
}

export function clearInPersonSession(): void {
   sessionStorage.removeItem(STORAGE_KEY)
}
